/**
 * Created by dongxingbin on 17/7/28.
 */

const base = ''
// const base = '/api'

export const login = base + '/login';

export const userList = base + '/user/list';

export const userListpage = base + '/user/listpage';

export const userRemove = base + '/user/remove';

export const userBatchremove = base + '/user/batchremove';

export const userEdit = base + '/user/edit';

export const userAdd = base + '/user/add';

//category
export const categoryList = base + '/category/list';

export const categoryListpage = base + '/category/listpage';

export const categoryRemove = base + '/category/remove';

export const categoryBatchremove = base + '/category/batchremove';

export const categoryEdit = base + '/category/edit';

export const categoryAdd = base + '/category/add';

//maintain
export const maintainList = base + '/maintain/list';

export const maintainListpage = base + '/maintain/listpage';
// export const maintainListpage = base + '/MaintainService.svc/GetMaintainItems';

export const maintainRemove = base + '/maintain/remove';

export const maintainBatchremove = base + '/maintain/batchremove';

export const maintainEdit = base + '/maintain/edit';

export const maintainAdd = base + '/maintain/add';

//plan
export const planList = base + '/plan/list';

export const planListpage = base + '/plan/listpage';

export const planRemove = base + '/plan/remove';

export const planBatchremove = base + '/plan/batchremove';

export const planEdit = base + '/plan/edit';

export const planAdd = base + '/plan/add';



// WEBPACK FOOTER //
// ./src/api/urlConfig.js